module.exports = __webpack_public_path__ + "static/media/NumPy.77964693.svg";